import { Info } from "lucide-react";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "../../../../../ui/hover-card";

interface TooltipInfoProps {
  title: string;
  description: string;
}

export const TooltipInfo = ({ title, description }: TooltipInfoProps) => (
  <HoverCard openDelay={100} closeDelay={100}>
    <HoverCardTrigger asChild>
      <button
        type="button"
        className="inline-flex items-center justify-center rounded-full text-muted-foreground/60 hover:text-muted-foreground transition-colors focus:outline-none"
        aria-label={title}
      >
        <Info className="h-3.5 w-3.5" />
      </button>
    </HoverCardTrigger>
    <HoverCardContent
      side="top"
      align="center"
      sideOffset={6}
      className="w-[260px] rounded-lg border-none bg-[hsl(222,47%,11%)] p-3.5 text-white shadow-lg animate-in fade-in-0 zoom-in-95 duration-150"
    >
      <p className="text-xs font-semibold mb-1.5">{title}</p>
      <p className="text-[11px] leading-relaxed whitespace-pre-line opacity-90">
        {description}
      </p>
    </HoverCardContent>
  </HoverCard>
);
